export default "__VITE_ASSET__c3b0eb77__"